import { useNotifications } from '@/composables/useNotifications'

export const useNotificationStore = defineStore('notification', () => {
  const unreadCount = ref(0)

  const { countUnread } = useNotifications()

  async function fetchUnreadCount() {
    const { data, error } = await countUnread()

    if (!error.value && data.value)
      unreadCount.value = data.value.data.count
  }

  function decrementUnread() {
    if (unreadCount.value > 0)
      unreadCount.value -= 1
  }

  function resetUnread() {
    unreadCount.value = 0
  }

  function setUnreadCount(count: number) {
    unreadCount.value = count
  }

  return { unreadCount, fetchUnreadCount, decrementUnread, resetUnread, setUnreadCount }
})
